import { loginHttpHelper } from "./HttpServiceUtils/HttpHelper";

export const UserProfilePopup = async (data) => {
    const response = await loginHttpHelper.put('/Users', data);
    return { response };
}